/**
 * Which Basic Animal Information fields the resident's property config set hides from them, and
 * whether the documents section is hidden too.
 *
 * Only what is hidden travels. Required-ness stays where it always lived — the backend step
 * verifier grades the animal and returns per-field failures — and "optional" is not a state the
 * app has to be told about, because a field that is neither required nor hidden is simply shown
 * and not enforced, which is what every field already does here.
 */
export enum EAnimalInfoConfig {
  ANIMAL_PHOTO = 'ANIMAL_PHOTO',
  ANIMAL_BIRTHDAY = 'ANIMAL_BIRTHDAY',
  ANIMAL_SPECIES = 'ANIMAL_SPECIES',
  ANIMAL_BREED = 'ANIMAL_BREED',
  ANIMAL_GENDER = 'ANIMAL_GENDER',
  ANIMAL_COLOR = 'ANIMAL_COLOR',
  ANIMAL_WEIGHT = 'ANIMAL_WEIGHT',
  MICROCHIP_NUMBER = 'MICROCHIP_NUMBER',
  SPAYED_NEUTERED = 'SPAYED_NEUTERED',
  HOUSE_TRAINED = 'HOUSE_TRAINED',
  HISTORY_OF_AGGRESSION = 'HISTORY_OF_AGGRESSION',
  SERVICE_ANIMAL_SPECIFIED_TRAINED_FOR_OBSERVABLE_DISABILITY = 'SERVICE_ANIMAL_SPECIFIED_TRAINED_FOR_OBSERVABLE_DISABILITY',
}

export type TAnimalFieldVisibilityDB = {
  hiddenRequirements: EAnimalInfoConfig[] | null;
  hideDocumentsSection: boolean;
};

export type TAnimalFieldVisibilityUI = {
  hiddenRequirements: EAnimalInfoConfig[];
  hideDocumentsSection: boolean;
};
